import React = require('react');
import { Field, InjectedFormProps } from 'redux-form';
import { IProduct } from '../../../../../data/api/models';
import { IQuoteState } from '../../../../../services/quote/models';
import { get, map } from 'lodash';
import { isRequired } from '../../../../../util/validators';
import { ButtonAsRadio } from '../../../../../components/ButtonRadioStyle';

interface IMaxTripDurationSelectorProps extends InjectedFormProps {
  product: IProduct;
  quoteState: IQuoteState;
  recalculate?: () => any;
}

export const MaxTripDurationSelector = ({
                                          product,
                                          recalculate = null,
                                          quoteState,
                                          ...props
                                        }: IMaxTripDurationSelectorProps) => {

  const annualTripDuration = map(get(product, 'metadata.annual_trip_durations', {}), (name, key) => {
    return {
      label: name,
      value: parseInt(key, 10),
    };
  });

  const renderMaxTripDurations = () => {
    return (
      <>
        <div className={'trip-duration-container'}>
          {map(annualTripDuration, (list, key) => {
            return (
              <div className="trip-duration-btn-container">
                <div>
                  <Field
                    name="maxTripDuration"
                    simpleValue={list.value}
                    className={'admiral-grey-btn'}
                    secondaryClass={'admiral-selected-green-btn'}
                    style={{
                      height: '60px',
                      borderRadius: '5px',
                      maxWidth: '150px',
                      whiteSpace: 'normal',
                      margin: 'auto'
                    }}
                    selectedText={list.label}
                    unSelectedText={list.label}
                    disabled={quoteState.isCalculating}
                    component={ButtonAsRadio}
                    validate={[isRequired]}
                    handleChange={recalculate ? recalculate : null}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </>
    );
  }


  return (
    <div>
      {renderMaxTripDurations()}
    </div>
  )
}
